<div [formGroup]="formGroup">
  <h3>{{ settings.nazev }}<span *ngIf="settings.povinnost" class="required"> *</span></h3>
  <mat-icon *ngIf="settings.napoveda && settings.napoveda.isIcon" matSuffix [matTooltip]="settings.napoveda.text">info</mat-icon>
  <p *ngIf="settings.napoveda && !settings.napoveda.isIcon">{{settings.napoveda.text}}</p>
  <textarea (froalaInit)="initializeFroala($event)" [froalaEditor]="froalaOptions" [formControlName]="settings.formControlName" contenteditable="false"></textarea>
</div>


